export const AUTH_STORE_KEY = 'AUTH_STORE';
export const REGISTRATION_STORE_KEY = 'REGISTRATION_STORE';
